import { useCallback, useRef, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const CLUSTER_URL = '/discover';

// Eureka's default stylesheet looks busy when embedded — flatten the
// body background and drop the navbar's top border so the iframe blends
// with the white admin pane. Works because the iframe is same-origin
// (dev proxy / shared nginx in prod).
const EUREKA_OVERRIDES_CSS = `
  body#one { background-color: #ffffff !important; }
  .navbar { border-top: none !important; }
`;

export function AdminClusterPage(): ReactElement {
  const { t } = useTranslation();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleLoad = useCallback(() => {
    try {
      const doc = iframeRef.current?.contentDocument;
      if (!doc) return;
      const style = doc.createElement('style');
      style.textContent = EUREKA_OVERRIDES_CSS;
      doc.head.appendChild(style);
    } catch {
      // Cross-origin or detached document — leaving the original colour
      // is a recoverable failure mode.
    }
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={CLUSTER_URL}
      title={t('routes.admin.cluster.iframeTitle')}
      referrerPolicy="same-origin"
      onLoad={handleLoad}
      className="h-full w-full border-0"
    />
  );
}
